import { combineReducers } from 'redux';

import relatorio from './relatorio/reducer';

export default combineReducers({
	relatorio,
});
